
(function ($) {
  $(document).ready(function () {
    const checkout_price_onepay = window.theme.checkout_price_onepay;
    const show_checkout_price_onepay = window.theme.show_checkout_price_onepay;

    const checkout_price_payoo = window.theme.checkout_price_payoo;
    const disable_installment_payoo_mode = window.theme.disable_installment_payoo_mode;

    const config_product_sixd = window.theme.config_product_sixd;
    const config_exclusion_based_on_8d = window.theme.config_exclusion_based_on_8d;
    const label_zero_installment = window.theme.label_zero_installment;
    const label_coming_soon = window.theme.label_coming_soon;
    const label_free_installation = window.theme.label_free_installation;
    const label_sold_out = window.theme.label_sold_out;
    const label_add_to_cart = window.theme.label_add_to_cart;
    const label_pre_order = window.theme.label_pre_order;
    var zero_installment_products = "6873958481979,6873958350907,6873958187067,6873958318139,6873958088763,6535374995515,6939368587323,6906029867067,6906030424123,6906042417211,6906049265723,6907663155259,6907662729275,6907661942843,6907661516859,6907661254715,6907660730427,6906182828091,6999521853499,7005899325499,7005895917627,7005898080315,7005898604603,7005879107643,7005894475835,7032963956795,7032964317243,7032963530811,7038367432763,7038370381883,7038371594299,7038372216891,7038372806715,7032964120635,7038374477883,7038373855291,6621033693243,6785165295675,7056277045307,7092064976955,7092065370171,7092065206331,7086174863419";
    var free_installment_products = "6865696030779,6873757450299,6865696194619,6865696358459,7005894475835,7005899325499,7005895917627,7005898080315,7005898604603,7005879107643,7937312915635";

    showListProduct();

    function showListProduct() {
      if ($('.static-product-page').length > 0) {
        let listCollectionProduct = $('.static-product-page .collection');
        listCollectionProduct.map(function (i, ele) {
          let collectionID = $(ele).data('collection');

          $(ele).addClass('loader');

          callAPIGetCollection(collectionID).then(function (result) {
            showProduct(result, ele);
            $(ele).removeClass('loader');
          });
        });
      };
    }

    function callAPIGetCollection(collectionID) {
      let promiseObj = new Promise(function (resolve, reject) {
        callAPIWithTokenRefresh(`collections/${collectionID}/products`, 'get')
          .then(function (res) {
            resolve(res);
          }).catch(function (res) {
            reject([]);
          });
      });
      return promiseObj;
    }

    function showProduct(data, collectionElm) {
      if (data) {
        if (data.status) {
          let html_product = `
            <section class="section"><div class="container"><div class="list-products grid grid--large">
          `;

          for (let i = 0; i < Math.min(data.data.length, 50); i++) {
            let item = data.data[i];
            let variants = item?.variants;

            var priceNot0 = variants.filter((variant) => {
              return variant.price > 0;
            });

            let variant = priceNot0[0];
            let discount_html = '', old_price = '';

            if(variant) {
              if (variant.compare_at_price) {
                let discount = (variant.compare_at_price - variant.price) / variant.compare_at_price * 100;

                discount = Math.round(discount);

                if (discount) {
                  discount_html = ` <div class="discount"><span>Giảm giá</span><span class="price-save">${discount}%</span></div>`;
                }
                old_price = Shopify.formatMoney(variant.compare_at_price * 100, window.myprice);
              }

              let image = item.image != undefined ? item.image.src : '';
  
              var _tag = item.tags, _res = _tag.split(","), list_label = "", new_tag='';
              let requiredTag = '';

              let price_main = variant.price;
              let has_zero_installment = false;
              let has_zero_installment_text = label_zero_installment;

              const onepayInstallmentEnabled = price_main >= parseInt(checkout_price_onepay) && show_checkout_price_onepay;
              const payooInstallmentEnabled = price_main >= parseInt(checkout_price_payoo) && disable_installment_payoo_mode;

              if ((onepayInstallmentEnabled || payooInstallmentEnabled) && (zero_installment_products.indexOf(item.id) < 0)) {
                has_zero_installment = true;
              }
              
              if (has_zero_installment) {
                list_label += `
                  <span class="label label--custom zero_installment_label">${has_zero_installment_text}</span></br>
                `;
              }

              let has_config_exclusion_based_on_8d = false;
              let has_config_product_sixd = false;
              let _model = '';
              // default is_out_of_stock is TRUE
              let is_out_of_stock = true;
              let is_coming_soon = false;
              let is_pre_order = false;

              for (_i = 0; _i < _res.length; _i++) {
                var _required = _res[_i].includes("__required");
  
                if (_required) {
                  var label_class = _res[_i].replace('__required:', '');
                  label_class = label_class.trim();
                  label_class = label_class.replace(new RegExp(' ', 'g'), '_') + "_label";
                  label_class = label_class.toLowerCase();

                  requiredTag += `
                    <span class='label label--required ${label_class}'>${_res[_i].replace('__required:', '')}</span>
                  `;
                };

                // Product model tag
                if (_res[_i].includes("__model")) {
                  _model = _res[_i].replace('__model:', '');
                };
  
                // Product label custom tag
                var _label = _res[_i].includes("__label");
  
                if (_label) {
                  var label_class = _res[_i].replace('__label:', '');
                  label_class = label_class.trim();
                  label_class = label_class.replace(new RegExp(' ', 'g'), '_') + "_label";
                  label_class = label_class.toLowerCase();

                  let label_name = _res[_i].replace('__label:', '');
                  let label_name_lower = label_name.trim().toLowerCase();

                  if (label_name_lower == "pre order" || label_name_lower == "đặt hàng trước" || label_name_lower == "combo mới") {
                    is_pre_order = true;
                    setTimeout(() => {
                      $(this).find('.product__add-to-cart').text(label_name);
                    }, 1000);
                  }
  
                  if (label_name_lower == "hàng sắp về" || label_name_lower == "coming soon") {
                    setTimeout(() => {
                      $(this).find('.product__add-to-cart').text(label_name).attr('disabled', 'disabled');
                    }, 1000);
                    label_name = label_coming_soon;
                    is_coming_soon = true;
                  }

                  if(label_name_lower === 'pre order' || label_name_lower === 'đặt hàng trước') {
                    label_name = 'Đặt trước';
                  }

                  if(label_name_lower !== 'new' && label_name_lower !== 'sản phẩm mới') {
                    list_label += '<span class="label label--custom ' + label_class + '">' + label_name + '</span>';
                  }
                  else {
                    if(label_name_lower === 'new' || label_name_lower === 'sản phẩm mới') {
                      label_name = 'mới';
                    }

                    new_tag = `
                      <div class="product-item__labels labels">
                        <span class="label sản_phẩm_mới_label ${label_class}">
                          ${label_name}
                        </span>
                      </div>
                    `;
                  }
                };
  
                if (_res[_i].includes("_sixdcode")) {
                  let _sixdcode_tag = _res[_i].split('_sixdcode:')[1];

                  if (config_product_sixd.includes(_sixdcode_tag)) {
                    has_config_product_sixd = true;
                  }
                }

                if (_res[_i].includes("_modelcode")) {
                  let _modelcode_tag = _res[_i].split('_modelcode:')[1];
                  if (config_exclusion_based_on_8d.includes(_modelcode_tag)) {
                    has_config_exclusion_based_on_8d = true;
                  }
                }
              }
  
              let has_free_installment_text = label_free_installation;
              if (has_config_product_sixd && !has_config_exclusion_based_on_8d && (free_installment_products.indexOf(item.id) < 0)) {
                list_label += `<span class="label label--custom free_installment_label">${has_free_installment_text}</span>`
              }
  
              let form_add_to_cart ='';

              if (variants) {
                let text_add_to_cart = label_add_to_cart;
                let is_disable_add_to_cart = '';

                variants.map(function (_variant) {
                  /* if any variant has stock, is_out_of_stock = FALSE, otherwise BREAK */
                  if (_variant.inventory_quantity !== 0)
                    is_out_of_stock = false;

                  available = true;
                })

                if (is_out_of_stock) {
                  text_add_to_cart = label_sold_out;
                  is_disable_add_to_cart = 'disabled="disabled"';
                }

                if (is_pre_order) {
                  text_add_to_cart = label_pre_order;
                }

                if (is_coming_soon) {
                  text_add_to_cart = label_coming_soon;
                  is_disable_add_to_cart = 'disabled="disabled"';
                }

                form_add_to_cart += `
                  <div class="product-item__add-to-cart button-wrapper">
                    <a href="/products/${item.handle}" ${is_disable_add_to_cart} class="product__add-to-cart button button--primary button--orange">
                      ${text_add_to_cart}
                    </a>
                  </div>
                `;
              }

              html_product += `
                    <div class="grid__cell 1/2 1/3--lap-and-up 1/3--desk">
                      <div class="product-item product-item--push" data-product-id="${item.id}">
                        <figure class="product-item__image-container">
                          <div class="product-item__image-wrapper">
                            <a href="/products/${item.handle}">
                              <div class="aspect-ratio"> 
                                <img class="product-item__image image--fade-in lazyloaded" alt="${item.product_type}" src="${image}">

                                ${requiredTag}
                              </div>
                            </a>
                          </div>

                          ${new_tag}

                          ${discount_html}

                        </figure>

                        <div class="product-item__info">
                          <div class="product-item__labels product-item__labels-bellow labels">
                            ${list_label}
                          </div>
                          <h3 class="product-item__title">
                            <a href="/products/${item.handle}" tabindex="-1" aria-hidden="true" alt="${item.product_type}" class="link">
                              ${item.title}
                            </a>
                          </h3>

                          <div class="model-product">
                            ${_model}
                          </div>

                          <div class="product-content-bottom" 
                            data-price="${variant.price}"
                            data-variant-id="${variant.id}"
                            data-compare-price="${variant.compare_at_price }">
                            <span class="product-item__price product-item__price--new">
                              ${Shopify.formatMoney(variant.price * 100, window.myprice)}
                            </span>

                            <div class="tooltip-wrapper">
                              <span class="price-tooltip" translate="no">1</span>
                              <div class="tooltip-content">
                                <p>
                                  1. Giá được đề cập liên quan đến Giá bán lẻ được đề xuất bao gồm VAT và có thể thay đổi theo thời gian mà không cần thông báo trước.
                                </p>
                              </div>
                            </div>

                            ${
                              variant.compare_at_price ? `
                              <span class="product-item__price product-item__price--old">
                                ${variant.compare_at_price}
                              </span><br>
                              ` : ''
                            }

                            ${form_add_to_cart}
                          </div>
                        </div>

                        <div class="product-item__see-more button-wrapper ">
                          <a href="/products/${item.handle}" class="button button--primary">Xem chi tiết</a>
                        </div>
                      </div>
                    </div>`;
            }
          }

          html_product += `</div></div></section>`;

          const listProductIds = data.data.map((p) => Number(p.id)).slice(0,50);

          window.getOMSAccessToken().then((token) => {
            getPriceForProductListing(listProductIds, token, $(html_product), $(collectionElm));

          }).catch(err => console.log('error when call get OMS access token', err));

        }
      }
    }

    function getPriceForProductListing(listProductIds, token, productSectionElm, collectionElm) {
      const customerInfoElm = $('#customer-infor');
  
      const customerInfo = {
        customerId: customerInfoElm.data('customer-id'),
        partnerCode: customerInfoElm.data('partner-code'),
        customerEmail: customerInfoElm.data('customer-email'),
      };

      if(!customerInfo.customerId) return;
  
      $.ajax({
        method: 'POST',
        url: `${window.partner.omsGetPriceByListProductIds}`,
        headers: {
          'Authorization': `Bearer ${token}`,
          'issuer': window.partner.storeId.toString(),
          'Accept-Language': 'en-US'
        },
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify({
          'storeid': window.partner.storeId.toString(),
          'listproductid': JSON.stringify(listProductIds),
          'partnercode': customerInfo.partnerCode,
          'customeremail': customerInfo.customerEmail.toLowerCase()
        })
      }).done(result => {
        const resultValue = JSON.parse(result?.value);
         const listProductItems = productSectionElm.find('.product-item');
  
        listProductItems.each(function(_, item) {
          const productItemElm = $(item);
          const productItemId = productItemElm.data('product-id').toString();
          const productItemData = resultValue.find(item => item.productid === productItemId);
          
          if (!productItemData) return;
  
          const variantId = productItemElm.find('.product-content-bottom').data('variant-id').toString();
          const variantData = productItemData.variant.find(v => v.id === variantId);
  
          if (!variantData) return;
  
          const partnerOrginalPrice = variantData.price;
  
          if(!partnerOrginalPrice) return;
  
          const price = productItemElm.find('.product-content-bottom').data('price');
          const comparePrice = productItemElm.find('.product-content-bottom').data('compare-price');
  
          // update price
          updateProductItemPrice(price, comparePrice, partnerOrginalPrice, productItemElm);
        });
  
        collectionElm.append(productSectionElm)

      }).fail(err => {
        console.log('err: ', err);
  
      })

    }

    function updateProductItemPrice(price, comparePrice, partnerPrice, productItemElm) {
      if (comparePrice === "undefined") {
        productItemElm.find('.product-item__price').html(Shopify.formatMoney(Math.min(price, partnerPrice) * 100, window.myprice));
        return;
      }

      const newPrice = comparePrice ? Math.min(price, comparePrice, partnerPrice) : Math.min(price, partnerPrice);
      const oldPrice = comparePrice ? Math.max(price, comparePrice, partnerPrice) : Math.max(price, partnerPrice);
      const discountPercent = (oldPrice - newPrice) / oldPrice * 100;
  
      if((comparePrice && (price === newPrice) && (comparePrice === oldPrice)) || !comparePrice && (price === newPrice)) return;
  
      // update price ==> format money
      productItemElm.find('.product-content-bottom').data('new-price', newPrice);
  
      if (comparePrice && oldPrice > newPrice) {
        productItemElm.find(".product-item__image-container .discount").show();
        productItemElm.find(".product-item__image-container .discount .price-save").html(discountPercent.toFixed(0)+"%");

        productItemElm.find('.product-item__price--new').html(Shopify.formatMoney(newPrice * 100, window.myprice));
        productItemElm.find('.product-item__price--old').html(Shopify.formatMoney(oldPrice * 100, window.myprice));
      } 
      else {
        productItemElm.find(".product-item__image-container .discount").hide();
        productItemElm.find('.product-item__price').html(Shopify.formatMoney(newPrice * 100, window.myprice));
      };
    }
  })
}(jQuery));
